export const isInTest = () => process.env.JEST_WORKER_ID !== undefined;

/**
 * Used to mock away the fetch layer
 * @param body
 * @param response
 * @param method
 * @param code
 */
export const mockFetch = <T>(body: T, response: any = body, method = 'get', code = 200, ): void =>  {
	jest.spyOn(global, 'fetch')
		.mockImplementation((url: RequestInfo, init?: RequestInit | undefined): Promise<Response> =>  {
			return new Promise((resolve) => {
				resolve({
					url: url,
					status: code,
					json: () =>
						Promise.resolve(body),
				} as Response)
			})
		});
}

/**
 * Returns the nth (default is last) request to fetch.
 * But body is JSON.parse'd into an object again.
 * @param callIndex
 */
export const fetchLastCalledWith = (callIndex = 0) => {
	try {
		// @ts-ignore
		const request = global.fetch?.mock?.calls[callIndex][1];

		if (!request) {
			return undefined;
		}

		try {
			return {
				...request,
				body: JSON.parse(request.body),
			};
		}
		catch (error) {
			return request;
		}
	}
	catch (error) {
		return undefined;
	}
};

export const mockMatchMedia = () => {
	Object.defineProperty(window, 'matchMedia', {
		writable: true,
		value: jest.fn().mockImplementation(query => ({
			matches: false,
			media: query,
			onchange: null,
			addListener: jest.fn(), // deprecated
			removeListener: jest.fn(), // deprecated
			addEventListener: jest.fn(),
			removeEventListener: jest.fn(),
			dispatchEvent: jest.fn(),
		})),
	});
};